import React from 'react'

import { ConnectedRouter } from 'connected-react-router'
import { Provider } from 'react-redux'

import Routes from 'containers/Routes'

import AppCore from 'cores/AppCore'

const Bootstrap = () => (
    <Provider store={AppCore.store}>
        <ConnectedRouter history={AppCore.history}>
            <Routes />
        </ConnectedRouter>
    </Provider>
)

export default Bootstrap